import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BoardHeader from "./BoardHeader";
import BoardBody from "./BoardBody";
import {
  applyEgFilters,
  clearEgKanban,
  resetEg,
} from "../../../actions/eg-kanban";
import SavingOverlay from "./SavingOverlay";

const Board = (props) => {
  const {
    search: {
      range,
      customRange,
      custom: { from, to },
    },
  } = props;

  useEffect(() => {
    props.actions.applyEgFilters({ farmId: props.farmId });
    return () => props.actions.clearEgKanban();
  }, []);

  useEffect(() => {
    props.actions.resetEg();
  }, [range, customRange, from, to]);

  return (
    <>
      <SavingOverlay />
      <div className="eg-kanban-container mobile-h-100-scroll">
        <BoardHeader />
        <BoardBody farmId={props.farmId} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  search: {
    range: state.analyze.searchParams.range,
    customRange: state.analyze.searchParams.customRange,
    custom: state.analyze.searchParams.custom,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    { applyEgFilters, clearEgKanban, resetEg },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Board);
